import { render } from "./Pharmacy.vue?vue&type=template&id=4b88b17a&ts=true"
import script from "./Pharmacy.ts?vue&type=script&lang=ts&external"
export * from "./Pharmacy.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__